import { env } from './environment-types';

export const environment = env({
	name: 'preprod',
	production: false,
});
